import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

// Premium, calm empty state. Answers: what is this, why it's useful, what to do next.
export const EmptyState = ({
    icon: Icon,
    title,
    body,
    cta,
    ctaIcon: CtaIcon,
    onCta,
    testid,
    className = "",
    compact = false,
}) => (
    <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        data-testid={testid}
        className={`flex flex-col items-center justify-center rounded-3xl border border-dashed border-border bg-surface-1 px-6 text-center ${compact ? "py-10" : "py-16"} ${className}`}
    >
        {Icon && (
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-surface-2 text-[hsl(var(--primary))] ring-1 ring-[hsl(var(--primary))]/15">
                <Icon className="h-7 w-7" />
            </div>
        )}
        <h3 className="mt-4 font-sans-display text-lg font-semibold text-t1">{title}</h3>
        {body && <p className="mt-2 max-w-sm text-sm leading-relaxed text-t3">{body}</p>}
        {cta && onCta && (
            <Button
                data-testid={testid ? `${testid}-cta` : undefined}
                className="mt-5 gap-2 transition-transform duration-200 hover:-translate-y-0.5"
                onClick={onCta}
            >
                {CtaIcon && <CtaIcon className="h-4 w-4" />} {cta}
            </Button>
        )}
    </motion.div>
);
